import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'calendar-minus': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faCalendarMinus" */
        '@fortawesome/free-regular-svg-icons/faCalendarMinus'
    ),
    'copyright': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faCopyright" */
        '@fortawesome/free-regular-svg-icons/faCopyright'
    ),
    'envelope': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faEnvelope" */
        '@fortawesome/free-regular-svg-icons/faEnvelope'
    ),
    'face-grin-squint-tears': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faGrinSquintTears" */
        '@fortawesome/free-regular-svg-icons/faGrinSquintTears'
    ),
    'face-rolling-eyes': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faMehRollingEyes" */
        '@fortawesome/free-regular-svg-icons/faMehRollingEyes'
    ),
    'face-smile-beam': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSmileBeam" */
        '@fortawesome/free-regular-svg-icons/faSmileBeam'
    ),
    'floppy-disk': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSave" */
        '@fortawesome/free-regular-svg-icons/faSave'
    ),
    'grin-squint-tears': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faGrinSquintTears" */
        '@fortawesome/free-regular-svg-icons/faGrinSquintTears'
    ),
    'hand-point-up': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faHandPointUp" */
        '@fortawesome/free-regular-svg-icons/faHandPointUp'
    ),
    'paste': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faPaste" */
        '@fortawesome/free-regular-svg-icons/faPaste'
    ),
    'square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSquare" */
        '@fortawesome/free-regular-svg-icons/faSquare'
    ),
    'sticky-note': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faStickyNote" */
        '@fortawesome/free-regular-svg-icons/faStickyNote'
    ),
    'tired': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faTired" */
        '@fortawesome/free-regular-svg-icons/faTired'
    ),
    'window-maximize': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faWindowMaximize" */
        '@fortawesome/free-regular-svg-icons/faWindowMaximize'
    ),
    'window-restore': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faWindowRestore" */
        '@fortawesome/free-regular-svg-icons/faWindowRestore'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>